import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=f4ce825c&"
import script from "./SortList.vue?vue&type=script&lang=js&"
export * from "./SortList.vue?vue&type=script&lang=js&"
import style0 from "./SortList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports